(() => {
  if (customElements.get("filters-component")) return;

  // ============================
  // 🔧 Yapılandırma & İlişkiler
  // ============================

  const DEL = "§§";
  const norm = (s) => (s || "").toString().trim().toLowerCase();

  function parseEncPairs(str, keyFirst = true) {
    const out = {};
    if (!str || typeof str !== "string") return out;
    const parts = str.split(DEL).filter(Boolean);
    parts.forEach((part) => {
      const idx = part.indexOf("::");
      if (idx === -1) return;
      const a = part.slice(0, idx).trim();
      const b = part.slice(idx + 2).trim();
      if (!a || !b) return;
      if (keyFirst) {
        if (!out[a]) out[a] = [];
        if (!out[a].includes(b)) out[a].push(b);
      } else {
        out[a] = b;
      }
    });
    return out;
  }

  function parseEncGroupByFirst(str) {
    const out = {};
    if (!str || typeof str !== "string") return out;
    str.split(DEL).filter(Boolean).forEach((part) => {
      const idx = part.indexOf("::");
      if (idx === -1) return;
      const key = part.slice(0, idx).trim();
      const val = part.slice(idx + 2).trim();
      if (!key || !val) return;
      if (!out[key]) out[key] = [];
      if (!out[key].includes(val)) out[key].push(val);
    });
    return out;
  }

  function parseFilterRelationsJson(scriptEl) {
    const fallback = {
      brands: [],
      brandToSubbrands: {},
      subbrandToBrand: {},
      subbrandToCategories: {},
      brandToCategories: {},
      categoryToBrands: {},
      categoryToSubbrands: {},
      allCategories: [],
      subbrands: [],
      SUBBRANDS: {}
    };
    if (!scriptEl || !scriptEl.textContent) return fallback;
    let raw;
    try {
      raw = JSON.parse(scriptEl.textContent.trim());
    } catch {
      return fallback;
    }
    const brands = Array.isArray(raw.brands) ? raw.brands.filter(Boolean) : [];
    const brandToSubbrands = parseEncGroupByFirst(raw.brandToSubbrandsEnc);
    const subbrandToBrand = parseEncPairs(raw.subbrandToBrandEnc, false);
    const subbrandToCategories = parseEncGroupByFirst(raw.subbrandToCategoriesEnc);
    const brandToCategories = parseEncGroupByFirst(raw.brandToCategoriesEnc);
    const categoryToBrands = parseEncGroupByFirst(raw.categoryToBrandsEnc);
    const categoryToSubbrands = parseEncGroupByFirst(raw.categoryToSubbrandsEnc);
    const allCategoriesEnc = (raw.allCategoriesEnc && typeof raw.allCategoriesEnc === "string")
      ? raw.allCategoriesEnc.split(DEL).filter(Boolean) : [];
    const allCategories = [...new Set(allCategoriesEnc)];
    brands.forEach((b) => {
      if (!brandToSubbrands[b]) brandToSubbrands[b] = [];
    });
    const subbrands = [...new Set(Object.keys(subbrandToBrand))];
    const SUBBRANDS = {};
    subbrands.forEach((sub) => {
      SUBBRANDS[sub] = {
        brand: subbrandToBrand[sub] || "",
        categories: subbrandToCategories[sub] || []
      };
    });
    return {
      brands,
      brandToSubbrands,
      subbrandToBrand,
      subbrandToCategories,
      brandToCategories,
      categoryToBrands,
      categoryToSubbrands,
      allCategories,
      subbrands,
      SUBBRANDS
    };
  }

  const getOptionMeta = (optEl) => {
    const labelText =
      optEl.querySelector("label span")?.innerText?.trim() ||
      optEl.querySelector("label")?.innerText?.trim() ||
      "";
    const checkbox = optEl.querySelector('input[type="checkbox"]');
    return { label: labelText, checkbox };
  };

  const getAllOptions = (root) => Array.from(root.querySelectorAll(".filter__option"));

  // ============================
  // Debounce
  // ============================
  const debounce = (fn, ms = 250) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), ms);
    };
  };

  class FiltersComponent extends HTMLElement {
    constructor() {
      super();
      this.debouncedOnSubmit = debounce((event) => this.onChange(event), 150);
      this.debouncedUpdateFilters = debounce(() => this.updateDependentFilters(), 300);
      this.spinner = document.getElementById("spinner");
      this.filterCache = new Map();
      this.isUpdatingFilters = false;
    }

    connectedCallback() {
      const scriptEl = this.querySelector("script[data-filter-relations]");
      this.filterRelations = parseFilterRelationsJson(scriptEl);

      // Sayfa ilk yüklendiğinde URL'yi temizle
      this.cleanupInitialURL();

      // URL'den yaş kategorisini algıla ve otomatik seç
      this.autoSelectAgeFilter();

      this.querySelector("[data-form]")?.addEventListener("input", this.debouncedOnSubmit.bind(this));
      this.querySelector("[data-filter-sort]")?.addEventListener("change", (e) => this.onSortChange(e));

      ["data-opener", "data-close", "data-button-mobile-apply"].forEach((attr) => {
        this.querySelector(`[${attr}]`)?.addEventListener("click", this.toggle.bind(this));
      });

      ["data-clear", "data-button-mobile-clear"].forEach((attr) => {
        this.querySelector(`[${attr}]`)?.addEventListener("click", this.clear.bind(this));
      });

      this.querySelectorAll("[data-active]").forEach((e) => e.addEventListener("click", this.onRemove.bind(this)));
      this.querySelectorAll("[data-group]").forEach((e) => e.addEventListener("click", this.groupToggle.bind(this)));

      if (this.hasAttribute("open-desktop")) {
        this.expandedDesktop();
        window.addEventListener("resize", () => this.expandedDesktop());
      }

      // İlk yüklemede "akıllı" ilişkileri hazırla
      // Kategori filtresi şimdilik yoruma alındı - sonrasında ihtiyaç olursa kullanılabilir
      /*
      setTimeout(() => {
  this.querySelectorAll(".filter__group").forEach(group => {
    const title =
      group.querySelector(".filter__title")?.innerText?.trim().toLowerCase() ||
      group.querySelector("[data-group]")?.innerText?.trim().toLowerCase();

    if (title && title.includes("kategori")) {
      group.style.display = "none";
    }
  });
}, 0);
      */
      setTimeout(() => this.initializeDependentFilters(), 100);
    }

    expandedDesktop() {
      window.innerWidth > 767 ? this.setAttribute("open", "") : this.removeAttribute("open");
    }

    autoSelectAgeFilter() {
      // URL'den yaş kategorisini çıkar
      const pathname = window.location.pathname;
      
      // Yaş kategorisi eşleştirmeleri
      const ageMapping = {
        '0-1-yas': '0-1 yaş',
        '1-3-yas': '1-3 yaş',
        '1-3-yas-1': '1-3 yaş',
        '3-5-yas': '3-5 yaş',
        '3-5-yas-1': '3-5 yaş',
        '5-7-yas': '5-7 yaş',
        '5-7-yas-1': '5-7 yaş',
        '7-9-yas': '7-9 yaş',
        '9-yas': '9 yaş ve üzeri',
        '9-yas-ve-uzeri': '9 yaş ve üzeri'
      };
      
      // URL'deki koleksiyon handle'ını bul
      const collectionMatch = pathname.match(/\/collections\/([^\/]+)/);
      if (!collectionMatch) return;
      
      const collectionHandle = collectionMatch[1];
      const expectedAge = ageMapping[collectionHandle];
      
      if (!expectedAge) return;
      
      // Yaş filtresini bul ve işaretle
      const allOptions = this.querySelectorAll('.filter__option');
      allOptions.forEach(option => {
        const label = option.querySelector('label span')?.innerText?.trim() || 
                     option.querySelector('label')?.innerText?.trim() || '';
        const checkbox = option.querySelector('input[type="checkbox"]');
        
        // Eğer bu bir yaş filtresi ise ve doğru yaş aralığıysa
        if (checkbox && label.toLowerCase() === expectedAge.toLowerCase()) {
          // Eğer zaten checked değilse işaretle ve form'u güncelle
          if (!checkbox.checked) {
            checkbox.checked = true;
            // Filtre değişikliğini tetikle
            setTimeout(() => {
              this.debouncedUpdateFilters();
            }, 200);
          }
        }
      });
    }

    cleanupInitialURL() {
      // Sayfa ilk yüklendiğinde URL'deki parametreleri temizle
      const currentSearch = window.location.search;
      if (!currentSearch || !currentSearch.includes('filter.')) return;
      
      const cleanSearch = this.createCleanURL(currentSearch.substring(1));
      const newURL = `${window.location.pathname}${cleanSearch ? "?" + cleanSearch : ""}`;
      
      // Sadece URL farklıysa değiştir
      if (newURL !== window.location.pathname + currentSearch) {
        // Gerçek parametreleri state'e kaydet ki popstate olayında kullanabilelim
        history.replaceState({ 
          realParams: currentSearch.substring(1),
          cleanParams: cleanSearch 
        }, "", newURL);
      }
    }

    toggle() {
      if (this.hasAttribute("empty")) return;
      this.toggleAttribute("open");
      document.body.classList.toggle("no-scroll-mobile");
    }

    groupToggle(e) {
      e.currentTarget.toggleAttribute("close");
    }

    isBrand(label) {
      const fr = this.filterRelations || {};
      return (fr.brands || []).map(norm).includes(norm(label));
    }

    isSubbrand(label) {
      const fr = this.filterRelations || {};
      return (fr.subbrands || []).map(norm).includes(norm(label));
    }

    isCategory(label) {
      const fr = this.filterRelations || {};
      return (fr.allCategories || []).map(norm).includes(norm(label));
    }

    onSortChange(e) {
      e.preventDefault();
      this.onChange(null, e.target.value);
    }

    onChange(e, sortValue = null) {
      if (e) e.preventDefault();
      const form = this.querySelector("[data-form]");
      let searchParams = form ? new URLSearchParams(new FormData(form)).toString() : "";

      if (sortValue) searchParams += "&sort_by=" + sortValue;
      else {
        const sortSelect = this.querySelector("[data-filter-sort]");
        if (sortSelect) searchParams += "&sort_by=" + sortSelect.value;
      }

      this.renderHtml(searchParams);
      this.debouncedUpdateFilters();
    }

    onRemove(e) {
      e.preventDefault();
      const searchParams = e.currentTarget.search.replace("?", "");
      this.renderHtml(searchParams);
      setTimeout(() => this.debouncedUpdateFilters(), 300);
    }

    renderHtml(searchParams) {
      const query = new URLSearchParams(window.location.search).get("q");
      if (query && !searchParams.includes("q=")) searchParams = query ? "q=" + query + "&" + searchParams : searchParams;

      // Tarayıcı adres çubuğunda temiz URL göster (ama gerçek parametreleri saklı tut)
      this.updateURL(searchParams);
      
      // Shopify'a gerçek parametrelerle fetch yap
      const url = `${window.location.pathname}?section_id=${this.dataset.id}&${searchParams}`;
      spinnerLoader.enable(this.spinner);

      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, "text/html");
          document.querySelector("[data-filter-wrapper]").innerHTML =
            html.querySelector("[data-filter-wrapper]").innerHTML;
          if (this.hasAttribute("open")) document.querySelector("filters-component[data-enable-filters]")?.setAttribute("open", "");
          spinnerLoader.disable(this.spinner);
          this.reattachEventListeners();
        });
    }

    updateURL(params) {
      const fullParams = params;
      const cleanParams = this.createCleanURL(params);
      history.pushState({ params: fullParams }, "", `${window.location.pathname}${cleanParams ? "?" + cleanParams : ""}`);
    }

    createCleanURL(params) {
      if (!params) return "";
      
      const urlParams = new URLSearchParams(params);
      const cleanParams = new URLSearchParams();
      
      // Kısa ve temiz parametre isimleri
      const paramMap = {
        'filter.p.m.custom.brand': 'marka',
        'filter.p.m.custom.sub_brand': 'alt-marka',
        'filter.p.m.custom.age': 'yas',
        'filter.p.m.custom.kategori': 'kategori',
        'filter.v.price.gte': 'min-fiyat',
        'filter.v.price.lte': 'max-fiyat',
        'sort_by': 'sirala'
      };
      
      for (const [key, value] of urlParams.entries()) {
        let cleanKey = key;
        
        // Önce tam eşleşmeleri kontrol et
        if (paramMap[key]) {
          cleanKey = paramMap[key];
        }
        // Eğer tam eşleşme yoksa genel kuralları uygula
        else if (key.startsWith('filter.p.m.custom.')) {
          const customKey = key.replace('filter.p.m.custom.', '');
          cleanKey = customKey;
        } else if (key.startsWith('filter.v.')) {
          const variantKey = key.replace('filter.v.', '');
          if (variantKey.includes('.')) {
            // price.gte -> min-fiyat, price.lte -> max-fiyat gibi
            cleanKey = variantKey.replace('.gte', '-min').replace('.lte', '-max');
          } else {
            cleanKey = variantKey;
          }
        } else if (key.startsWith('filter.p.')) {
          cleanKey = key.replace('filter.p.', '');
        }
        
        // Değeri de temizle (özel karakterleri kaldır)
        let cleanValue = value;
        
        cleanParams.append(cleanKey, cleanValue);
      }
      
      return cleanParams.toString();
    }

    clear() {
      let searchParams = "";
      const sortParam = window.location.search.split("&sort_by=")[1];
      if (sortParam) searchParams = `sort_by=${sortParam}`;
      this.filterCache.clear();
      this.renderHtml(searchParams);
      setTimeout(() => this.showAllFilterOptions(), 300);
    }

    initializeDependentFilters() {
      const checked = this.querySelectorAll('input[type="checkbox"]:checked');
      if (checked.length > 0) this.updateDependentFilters();
    }

    reattachEventListeners() {
      const form = this.querySelector("[data-form]");
      if (form) {
        form.removeEventListener("input", this.debouncedOnSubmit);
        form.addEventListener("input", this.debouncedOnSubmit.bind(this));
      }

      this.querySelectorAll("[data-active]").forEach((e) => e.addEventListener("click", this.onRemove.bind(this)));
      this.querySelectorAll("[data-group]").forEach((e) => e.addEventListener("click", this.groupToggle.bind(this)));

      ["data-clear", "data-button-mobile-clear"].forEach((attr) => {
        const btn = this.querySelector(`[${attr}]`);
        if (btn) btn.addEventListener("click", this.clear.bind(this));
      });
    }

    // ============================
    // 🔄 Mevcut kullanılabilirlik kontrolü (Grid'e göre)
    // ============================
    async updateDependentFilters() {
      if (this.isUpdatingFilters) return;
      this.isUpdatingFilters = true;

      const scriptEl = this.querySelector("script[data-filter-relations]");
      if (scriptEl) this.filterRelations = parseFilterRelationsJson(scriptEl);

      try {
        const checked = this.querySelectorAll('input[type="checkbox"]:checked');
        if (checked.length === 0) {
          this.showAllFilterOptions();
          return;
        }

        const currentSelections = this.getCurrentSelections();

        // 1) Ürün var/yok kontrolü ile tüm seçenekleri (check edilmemişleri) güncelle
        //  await this.batchUpdateAllFilterOptions(currentSelections);

        // 2) İş kurallarına göre akıllı daraltma
        this.applyBusinessRules();
      } finally {
        this.isUpdatingFilters = false;
      }
    }

    getCurrentSelections() {
      const form = this.querySelector("[data-form]");
      const selections = {};
      if (form) {
        const formData = new FormData(form);
        for (let [key, value] of formData.entries()) {
          if (!selections[key]) selections[key] = [];
          selections[key].push(value);
        }
      }
      return selections;
    }

    async batchUpdateAllFilterOptions(currentSelections) {
      const allUncheckedOptions = [];
      this.querySelectorAll(".filter__group").forEach((group) => {
        const unchecked = group.querySelectorAll('.filter__option input[type="checkbox"]:not(:checked)');
        unchecked.forEach((checkbox) => {
          const option = checkbox.closest(".filter__option");
          const cacheKey = `${checkbox.name}:${checkbox.value}`;
          allUncheckedOptions.push({
            checkbox,
            option,
            cacheKey,
            testSelections: {
              ...currentSelections,
              [checkbox.name]: [...(currentSelections[checkbox.name] || []), checkbox.value]
            }
          });
        });
      });

      allUncheckedOptions.forEach(({ option }) => option.classList.add("filter-loading"));
      const checkPromises = allUncheckedOptions.map(async ({ checkbox, option, cacheKey, testSelections }) => {
        if (this.filterCache.has(cacheKey)) {
          return { option, isAvailable: this.filterCache.get(cacheKey) };
        }
        const isAvailable = await this.checkFilterCombination(testSelections);
        this.filterCache.set(cacheKey, isAvailable);
        return { option, isAvailable };
      });

      try {
        const results = await Promise.all(checkPromises);
        results.forEach(({ option, isAvailable }) => {
          option.classList.remove("filter-loading");
          this.toggleOptionVisibility(option, isAvailable);
        });
      } catch (e) {
        console.error("Batch update failed:", e);
        allUncheckedOptions.forEach(({ option }) => {
          option.classList.remove("filter-loading");
          this.toggleOptionVisibility(option, true);
        });
      }
    }

    async checkFilterCombination(selections) {
      try {
        const params = new URLSearchParams();
        Object.entries(selections).forEach(([k, vals]) => vals.forEach((v) => params.append(k, v)));
        const sortSelect = this.querySelector("[data-filter-sort]");
        if (sortSelect) params.append("sort_by", sortSelect.value);

        const testUrl = `${window.location.pathname}?section_id=${this.dataset.id}&${params.toString()}`;
        const res = await fetch(testUrl);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const grid = doc.querySelector("#product-grid");
        return grid && grid.children.length > 0;
      } catch {
        return true;
      }
    }

    toggleOptionVisibility(option, visible) {
      option.style.display = visible ? "" : "none";
      option.classList.toggle("filter-unavailable", !visible);
    }

    showAllFilterOptions() {
      this.querySelectorAll(".filter__option").forEach((o) => {
        o.style.display = "";
        o.classList.remove("filter-unavailable", "filter-loading");
      });
    }

    // ===========================================
    // 🎯 İŞ KURALLARI: MARKA / ALT MARKA / KATEGORİ
    //  - NOT-1: Sol filtre sıralaması: Marka / Alt Marka / Kategori / Yaş / Fiyat
    //  - NOT-2: Marka seçilince sadece o markanın Alt Marka ve Kategorileri görünür.
    //  - NOT-3: Alt Marka seçilince sadece ilgili Marka ve Kategoriler görünür.
    // ===========================================
    applyBusinessRules() {
      const fr = this.filterRelations || {};
      const BRANDS = fr.brands || [];
      const SUBBRANDS = fr.SUBBRANDS || {};
      const BRAND_TO_SUBBRANDS = fr.brandToSubbrands || {};
      const BRAND_TO_CATEGORIES = fr.brandToCategories || {};
      const CATEGORY_TO_BRANDS = fr.categoryToBrands || {};
      const CATEGORY_TO_SUBBRANDS = fr.categoryToSubbrands || {};
      const ALL_CATEGORIES = fr.allCategories || [];

      const allOptions = getAllOptions(this);

      const checkedOpts = Array.from(this.querySelectorAll('.filter__option input[type="checkbox"]:checked')).map((cb) =>
        cb.closest(".filter__option")
      );

      const selectedLabels = checkedOpts
        .map(getOptionMeta)
        .map(({ label }) => label)
        .filter(Boolean);

      const selectedBrands = selectedLabels.filter((l) => this.isBrand(l));
      const selectedSubbrands = selectedLabels.filter((l) => this.isSubbrand(l));
      // Kategori filtresi şimdilik yoruma alındı - sonrasında ihtiyaç olursa kullanılabilir
      // const selectedCategories = selectedLabels.filter((l) => this.isCategory(l));
      const selectedCategories = [];

      allOptions.forEach((opt) => (opt.style.display = ""));

      let allowedBrands = new Set(BRANDS);
      let allowedSubbrands = new Set(Object.keys(SUBBRANDS));
      let allowedCategories = new Set(ALL_CATEGORIES);

      if (selectedSubbrands.length > 0) {
        const subbrandsSet = new Set(selectedSubbrands);
        const brandsFromSubs = new Set(
          selectedSubbrands.map((s) => SUBBRANDS[s]?.brand).filter(Boolean)
        );
        const catsFromSubs = new Set(
          selectedSubbrands.flatMap((s) => SUBBRANDS[s]?.categories || [])
        );

        allowedBrands = brandsFromSubs;
        allowedSubbrands = subbrandsSet;
        allowedCategories = catsFromSubs;

        if (selectedCategories.length > 0) {
          const catsSelected = new Set(selectedCategories);
          allowedCategories = new Set([...allowedCategories].filter((c) => catsSelected.has(c)));
        }
      }
      else if (selectedBrands.length > 0) {
        const bSet = new Set(selectedBrands);
        allowedBrands = bSet;

        const allSubs = new Set(
          selectedBrands.flatMap((b) => BRAND_TO_SUBBRANDS[b] || [])
        );
        const allCats = new Set(
          selectedBrands.flatMap((b) => BRAND_TO_CATEGORIES[b] || [])
        );

        allowedSubbrands = allSubs;
        allowedCategories = allCats;

        if (selectedCategories.length > 0) {
          const catsSel = new Set(selectedCategories);
          allowedCategories = new Set([...allowedCategories].filter((c) => catsSel.has(c)));

          const subsFromCats = new Set(
            selectedCategories.flatMap((c) => (CATEGORY_TO_SUBBRANDS[c] || []).filter((s) => bSet.has(SUBBRANDS[s]?.brand)))
          );
          allowedSubbrands = new Set(
            [...allowedSubbrands].filter((s) => subsFromCats.has(s) || selectedSubbrands.includes(s))
          );
        }
      }
      else if (selectedCategories.length > 0) {
        const brandsFromCats = new Set(
          selectedCategories.flatMap((c) => (CATEGORY_TO_BRANDS[c] || []))
        );
        const subsFromCats = new Set(
          selectedCategories.flatMap((c) => (CATEGORY_TO_SUBBRANDS[c] || []))
        );
        allowedBrands = brandsFromCats.size ? brandsFromCats : allowedBrands;
        allowedSubbrands = subsFromCats.size ? subsFromCats : allowedSubbrands;
        allowedCategories = new Set(selectedCategories);
      }

      getAllOptions(this).forEach((opt) => {
        const { label, checkbox } = getOptionMeta(opt);
        if (!label) return;

        const n = norm(label);
        const checked = !!checkbox?.checked;

        if (this.isBrand(label)) {
          const show = allowedBrands.has(label) || checked;
          opt.style.display = show ? "" : "none";
        } else if (this.isSubbrand(label)) {
          const show = allowedSubbrands.has(label) || checked;
          opt.style.display = show ? "" : "none";
        } 
        // Kategori filtresi şimdilik yoruma alındı - sonrasında ihtiyaç olursa kullanılabilir
        /*
        else if (this.isCategory(label)) {
          const equivalentHit =
            [...allowedCategories].some((c) => norm(c) === n) ||
            (n.includes("peluş oyuncak") &&
              [...allowedCategories].some((c) => norm(c).includes("peluş oyuncak")));
          const show = equivalentHit || checked;
          opt.style.display = show ? "" : "none";
        } 
        */
        else {
          opt.style.display = "";
        }
      });
    }
  }

  customElements.define("filters-component", FiltersComponent);
})();
